import { Icon } from 'components/ui'

import { CheckboxWrapper, CheckboxLabel, CheckboxInput, CheckboxContainer, CheckboxIcon } from './Style'

type Props = {
  id?: string
  name?: string
  checked?: boolean
  disabled?: boolean
  autoFocus?: boolean
  onClick?: (checked: boolean, name?: string) => void
}

function Checkbox({ id, checked, name, disabled, autoFocus, onClick }: Props) {
  const handleChange = () => {
    if (typeof onClick === 'function') {
      onClick(!Boolean(checked), name)
    }
  }

  return (
    <CheckboxWrapper>
      <CheckboxLabel>
        <CheckboxInput
          id={id}
          type='checkbox'
          checked={checked}
          disabled={disabled}
          autoFocus={autoFocus}
          onChange={handleChange}
        />
        <CheckboxContainer>
          <CheckboxIcon>
            <Icon name='tick' size='extraMedium' />
          </CheckboxIcon>
        </CheckboxContainer>
      </CheckboxLabel>
    </CheckboxWrapper>
  )
}

export { Checkbox }
